.ClearBoth {
    clear: both;
    height: 0px;
}

.HiddenPanel {
    display: none;
}

:host {
  display: block;
}

:host div#InterestFormStage {
    /* padding: 0px 12px 12px 12px; */
    font-family: Arial, Helvetica, sans-serif;
    font-size: 0.8em;
    width: 260px;
}

:host div#InterestFormStage ion-button {
    float: right;
    margin-top: 12px;
    margin-right: 12px;
    max-height: 40px !important;
}

:host div#InterestFormStage ion-label {
    font-size: 0.9em;
}

:host div#InterestFormStage ion-input {
    font-size: 0.9em;
}

:host ion-select {
    margin-left: 12px;
    margin-right: 10px;
}

:host .SessionSelector {
    max-width: unset !important;
    width: 100% !important;
}

ion-select::part(text) {
    font-size: 1.5em !important;
    color: #2c64ff;
}
